<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QndjnY/tc-custom/9781467466608.jpg?1742010694335" alt="This image is the cover for the book Jesus Is the Christ"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jesus Is the Christ
      </h1>
      <p class="bookDescription body article font2">
        <p>More than simply a series of chapters on the theology of John's Gospel, <i>Jesus Is the Christ</i> relates each of John's teachings to his declared aim, expressed in John 20: 30-31: "Jesus did many other signs before his disciples, which have not been written in this book; but these have been written that you may believe that Jesus is the Christ, the Son of God, and that believing you may have life in his name." Indeed, each chapter in Morris's book takes up some facet or aspect of John's expressed aim.<br/><br/>For an age still asking the question "Who is Jesus?" Leon Morris argues convincingly that John's entire Gospel was written to show that the human Jesus is the Christ, or Messiah, as well as the Son of God. But it is Morris's firm conviction that John's purpose was evangelical as well as theological -- that is, John wrote his book so that readers might believe in Christ and as a result have eternal life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Leon Morris
      </h2>
      
      <p class="authorDescription body article">&#160;<B>Leon Morris</B>&#160;(1914-2006) was one of Australia&#39;s most prolific Bible scholars. He wrote over forty other books, including commentaries on Matthew, John, and Thessalonians.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?82296b04